import * as React from "react";
import "./ExpandableTableRow.css";

export interface ExpandableTableRowProps {
    expandedContent: React.ReactElement;
}

export const ExpandableTableRow = ({
    children,
    expandedContent
}: React.PropsWithChildren<ExpandableTableRowProps>) => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    const containerRef = React.useRef(null);
    const innerRef = React.useRef(null);


    const toggleExpander = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <tr style={{ cursor: 'pointer' }} onClick={toggleExpander}>
                <td className="col-md-1"><span className={isExpanded ? "fas fa-chevron-up" : "fas fa-chevron-down"}></span>&nbsp;</td>
                {children}
            </tr>
            {isExpanded ? <tr ref={containerRef}>
                <td className="inner" ref={innerRef} colSpan={100}>
                    {expandedContent}
                </td>
            </tr> : null}
        </>
    );
};
